import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

export class DarethsFoyer extends Scene {
  title = "Dareth's Foyer";
  image = require("@/images/Dareths_Foyer.png");
  get options(): any[] {
    return [
      new Choice("Look in Kitchen", async () =>
        await this.navigate(scenes.DarethsKitchen())
      ),
      new Choice("Go Upstairs", async () => await this.navigate(scenes.DarethsUpstairs())),
      new Choice("Go Back", async () => await this.navigate(scenes.FrontDoor())),
    ];
  }
}

export default new DarethsFoyer();
